<template>
  <div class="d-inline-block">
    <v-btn
      size="x-small"
      color="primary"
      variant="text"
      icon="mdi-calendar-range"
      aria-label="Set project timeline"
      @click="open"
    ></v-btn>

    <v-dialog v-model="dialog" max-width="520">
      <v-card prepend-icon="mdi-calendar-range" title="Project timeline">
        <v-card-text>
          <div class="text-body-2 text-grey mb-3">
            Project: <strong>{{ project && project.title }}</strong>
          </div>
          <v-row dense>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="startDate"
                type="date"
                label="Planned start"
                density="compact"
                variant="outlined"
                prepend-inner-icon="mdi-calendar-start"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="endDate"
                type="date"
                label="Target end"
                density="compact"
                variant="outlined"
                prepend-inner-icon="mdi-calendar-end"
                :min="startDate || undefined"
                clearable
              ></v-text-field>
            </v-col>
          </v-row>
          <v-checkbox
            v-model="backfill"
            density="compact"
            hide-details
            color="primary"
            label="Fill missing sprint/ticket dates from this window"
          ></v-checkbox>
          <div class="text-caption text-grey mt-1">
            Only sprints/tickets with no dates yet are filled — existing dates are kept.
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text="Close" variant="plain" @click="dialog = false"></v-btn>
          <v-btn
            color="primary"
            text="Save"
            variant="flat"
            :loading="saving"
            :disabled="!!startDate && !!endDate && endDate < startDate"
            @click="save()"
          ></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';
import constant from '@/constant';
import utils from '@/utils';
import apiMixin from '@/mixins/apiMixin';

export default {
  name: 'EditProjectTimeline',
  mixins: [apiMixin],
  props: {
    project: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      saving: false,
      startDate: null,
      endDate: null,
      backfill: true,
      constant: constant,
    };
  },
  methods: {
    open() {
      this.startDate = this.project.start_date ? String(this.project.start_date).slice(0, 10) : null;
      this.endDate = this.project.end_date ? String(this.project.end_date).slice(0, 10) : null;
      this.backfill = true;
      this.dialog = true;
    },
    save() {
      this.saving = true;
      const payload = {
        id: this.project.id,
        start_date: this.startDate || null,
        end_date: this.endDate || null,
        backfill: this.backfill,
      };
      axios.post(utils._api(this.constant.update_project_timeline), payload, this.authHeaders())
        .then((response) => {
          this.saving = false;
          this.dialog = false;
          this.$emit('updated', response.data.data);
          this.$emit('toggle-message', response.data.message);
        })
        .catch((error) => {
          this.saving = false;
          console.error('Error updating timeline:', error);
          const msg = error.response && error.response.data && error.response.data.message
            ? error.response.data.message
            : 'Failed to update timeline';
          this.$emit('toggle-message', msg);
        });
    },
  },
};
</script>
